import React, { useState } from 'react';
import {
  Box, Button, Stack, Typography, Paper
} from '@mui/material';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, Legend, PieChart, Pie, Cell
} from 'recharts';
import { LoaderBoxCircular } from '../Components/LoaderBox';
import { instance } from '../Components/config';

const colores = ['#4caf50', '#f44336']; // Verde para cumple, rojo para no cumple

function GraficoCumplimiento2() {
  const [tipoGrafica, setTipoGrafica] = useState('barras');
  const [isLoading, setIsLoading] = useState(true);

  const [data, setData] = useState([]);

  function obtenerDatos(){
    instance.get('/reporte/cumplimientoUpse2')
    .then((res) => {
      const datosTransformados = res.data.map((item) => ({
        ...item,
        cumple: Number(item.cumple),
        no_cumple: Number(item.no_cumple),
      }));
      setData(datosTransformados);
    })
    .catch((error) => {
      console.log(error)
    })
    .finally(() => {
      setIsLoading(false);
    })
  }

  if(isLoading){
    obtenerDatos();
  }

  return (
    <Paper elevation={3} sx={{ p: 3, mt: 4 }}>
      <Typography variant="h6" gutterBottom>
        Cumplimiento de presentación por usuario
      </Typography>
      <p>Este reporte indica los usuarios que presentaron el formulario UPSE-2 durante el primer mes del año.</p>

      <LoaderBoxCircular isLoading={isLoading}>
        <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
          <Button
            variant={tipoGrafica === 'barras' ? 'contained' : 'outlined'}
            onClick={() => setTipoGrafica('barras')}
          >
            Gráfica de Barras
          </Button>
          <Button
            variant={tipoGrafica === 'pastel' ? 'contained' : 'outlined'}
            onClick={() => setTipoGrafica('pastel')}
          >
            Gráfica de Pastel
          </Button>
        </Stack>

        {tipoGrafica === 'barras' ? (
          <BarChart width={600} height={300} data={data}>
            <XAxis dataKey="nombre_usuario" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="cumple" fill={colores[0]} name="Cumple" />
            <Bar dataKey="no_cumple" fill={colores[1]} name="No cumple" />
          </BarChart>
        ) : (
          <Stack direction="row" spacing={4}>
            {data.map((usuario, index) => {
              const pieData = [
                { name: 'Cumple', value: usuario.cumple },
                { name: 'No cumple', value: usuario.no_cumple }
              ];
              return (
                <Box key={index}>
                  <Typography variant="body1" align="center" gutterBottom>
                    {usuario.nombre_usuario}
                  </Typography>
                  <PieChart width={200} height={200}>
                    <Pie
                      data={pieData}
                      dataKey="value"
                      cx="50%"
                      cy="50%"
                      outerRadius={60}
                      label
                    >
                      {pieData.map((entry, idx) => (
                        <Cell key={`cell-${idx}`} fill={colores[idx]} />
                      ))}
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </Box>
              );
            })}
          </Stack>
        )}
      </LoaderBoxCircular>
    </Paper>
  );
};

export { GraficoCumplimiento2 };
